import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../ui/src/component/icon';
import './player.css';
import { getProp } from '../../../ui/src/utilities';

class Player extends React.Component {
  constructor(props) {
    super(props);

    this.streams = {
      64: 'https://stream.21.sk/radiokosice-64.mp3',
      128: 'https://stream.21.sk/radiokosice-128.mp3',
    };

    this.state = {
      source: this.streams['128'],
      playing: false,
      volume: 0,
      wasPlayingBeforePause: false,
    };

    this.audioEl = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forcePause === true && this.props.forcePause === false) {
      if (this.state.playing) {
        this.setState({ wasPlayingBeforePause: true });
        this.stopStream();
      } else {
        this.setState({ wasPlayingBeforePause: false });
      }
    } else if (
      nextProps.forcePause === false &&
      this.props.forcePause === true
    ) {
      if (this.state.wasPlayingBeforePause) {
        this.playStream();
      }
      if (this.state.playing) {
        this.stopStream();
      }
    }
  }

  componentDidMount() {
    let hash = getProp(window.location, 'hash', '');
    if (hash === '#play') {
      this.playStream();
    } else if (hash === '#play128') {
      this.setState({ source: this.streams['128'] }, () => {
        this.playStream();
      });
    } else if (hash === '#play64') {
      this.setState({ source: this.streams['64'] }, () => {
        this.playStream();
      });
    }

    this.setVolume(0.25);
  }

  onChangeBitrate(bitrate) {
    let oldSource = this.state.source;
    let newSource = bitrate === 64 ? this.streams['64'] : this.streams['128'];
    this.stopStream();
    this.setState({ source: newSource }, () => {
      if (newSource !== oldSource) {
        this.audioEl.load();
      }
      this.playStream();
    });
  }

  get currentStreamValue() {
    let text = 0;
    Object.keys(this.streams).map((bitrate) => {
      if (this.streams[bitrate] === this.state.source) {
        text = bitrate;
      }
      return true;
    });
    return text;
  }

  playStream() {
    if (typeof window !== 'undefined' && window && window.ga) {
      window.ga(
        'send',
        'event',
        'onair',
        'play',
        `Prehratie rádia ${this.currentStreamValue}kbps`,
      );
    }
    this.setState({ playing: true }, () => {
      this.audioEl.play();
    });
  }

  stopStream() {
    if (typeof window !== 'undefined' && window && window.ga) {
      window.ga(
        'send',
        'event',
        'onair',
        'stop',
        `Prehratie rádia ${this.currentStreamValue}kbps`,
      );
    }
    this.setState({ playing: false }, () => {
      this.audioEl.pause();
    });
  }

  onClickPlay() {
    if (this.state.playing) {
      this.stopStream();
    } else {
      this.playStream();
    }
  }

  onChangeVolume(ev) {
    this.setVolume(ev.target.value);
  }

  setVolume(volume) {
    this.setState({ volume }, () => {
      this.audioEl.volume = this.state.volume;
    });
  }

  render() {
    return (
      <div className="player">
        <audio ref={(el) => (this.audioEl = el)} preload={'none'}>
          <source src={this.state.source} type="audio/mp3" />
        </audio>
        <div className="player-container">
          <div className="player-content">
            <a onClick={this.onChangeBitrate.bind(this, 64)}>
              <Icon
                name={
                  this.state.playing && this.state.source === this.streams['64']
                    ? 'speaker'
                    : 'speaker-mute'
                }
              />{' '}
              64&nbsp;Kbps
            </a>
            <a onClick={this.onChangeBitrate.bind(this, 128)}>
              <Icon
                name={
                  this.state.playing &&
                  this.state.source === this.streams['128']
                    ? 'speaker'
                    : 'speaker-mute'
                }
              />{' '}
              128&nbsp;Kbps
            </a>
            <div className="player-volume">
              <div
                className="player-volume-state"
                style={{ width: `${this.state.volume * 100}%` }}
              />
              <input
                type="range"
                className="player-volume-range"
                min={0}
                max={1}
                step="any"
                onChange={this.onChangeVolume.bind(this)}
                value={this.state.volume}
              />
            </div>
          </div>
        </div>
        <button className="ls-button" onClick={this.onClickPlay.bind(this)}>
          <Icon name="live-stream" size="md" />
        </button>
      </div>
    );
  }
}

Player.defaultProps = {
  forcePause: false,
};

Player.propTypes = {
  forcePause: PropTypes.bool,
};

export default Player;



// WEBPACK FOOTER //
// ./src/app/component/player/player.js